// src/lib/personen.js
// Wie ein Mitarbeiter in der App angesprochen wird.
//
// Hintergrund: Legt Supabase einen Nutzer an, ohne dass ein Name mitgegeben
// wurde, traegt der Trigger die E-Mail als Name ein. Auf der Startseite stand
// dann "Guten Morgen, anna-lena.hochuli@etb-karlsruhe.de". Solange der Name
// nicht gepflegt ist, wird er hier aus der Adresse abgeleitet.

const grossAnfang = (w) => (w ? w[0].toUpperCase() + w.slice(1) : w);

// "anna-lena.hochuli@etb-karlsruhe.de"  ->  "Anna-Lena Hochuli"
function ausEmail(email) {
  const vorm = String(email || '').split('@')[0];
  if (!vorm) return '';
  return vorm
    .split(/[._]+/)
    .map(teil => teil.split('-').map(grossAnfang).join('-'))
    .join(' ')
    .trim();
}

// Voller Anzeigename.
export function anzeigeName(profile, user) {
  const roh = (profile?.name || '').trim();
  if (roh && !roh.includes('@')) return roh;
  // Steht im Namen selbst eine Adresse (so legt Supabase neue Nutzer an), ist
  // sie immer noch die beste Quelle - auch wenn das E-Mail-Feld leer bleibt.
  return ausEmail(profile?.email || user?.email || roh) || 'Kollege';
}

// Wie jemand angesprochen wird. Wir duzen uns, also der Vorname - oder der
// Rufname, wenn einer gepflegt ist: Samira heisst bei allen "Sascha".
export function vornameVon(profile, user) {
  const ruf = (profile?.rufname || '').trim();
  if (ruf) return ruf;
  return anzeigeName(profile, user).split(' ')[0];
}
